export enum MapMarkersTypeEnum {
  MAP_MARKER_TYPE_EQUALS = 'MAP_MARKER_TYPE_EQUALS',
  MAP_MARKER_TYPE_RANGE = 'MAP_MARKER_TYPE_RANGE'
}
